export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وأكد كود التوثيق من تطبيق التوثيق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-DZ": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وأكد كود التصديق من تطبيق التصديق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-EG": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل و أكد كود التوثيق من تطبيق التوثيق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-LB": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وأكد رمز التفويض من تطبيق التفويض."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-MA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وأكد رمز التوثيق من تطبيق التوثيق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ادخل رمز التأكيد"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-SA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل وتأكد من كود التصديق من تطبيق التصديق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-SY": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل و أكد الرمز من تطبيق التوثيق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-TN": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل واكد الرمز من تطبيق التوثيق."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رمز التحقق"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق من تطبيق التوثيق"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "bg-BG": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете и потвърдете кода за удостоверяване от приложението за удостоверяване."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете код за удостоверяване"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване от приложението за удостоверяване"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване от приложението за удостоверяване"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение за удостоверяване"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        }
      },
      "bs-BA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite autentifikacijski kod iz autentifikacijske aplikacije."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite kod za autentifikaciju"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        }
      },
      "cs-CZ": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte a potvrďte ověřovací kód z ověřovací aplikace."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte ověřovací kód"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační kód z autentizační aplikace"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační kód z autentizační aplikace"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační aplikace"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        }
      },
      "da-DK": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast og bekræft godkendelseskoden fra godkendelsesappen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast godkendelseskode"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringskode fra autentificeringsappen"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringskode fra autentificeringsappen"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringsapp"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        }
      },
      "de-DE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App eingeben und bestätigen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-Code aus der Authentifizierungs-App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-AT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App eingeben und bestätigen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-Code aus der Authentifizierungs-App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-CH": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App eingeben und bestätigen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-Code aus der Authentifizierungs-App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-LU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App eingeben und bestätigen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der Authentifizierungs-App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-Code aus der Authentifizierungs-App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "el-GR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε και επιβεβαιώστε τον κωδικό πιστοποίησης από την εφαρμογή πιστοποίησης."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "el-CY": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε και επιβεβαιώστε τον κωδικό επαλήθευσης από την εφαρμογή επαλήθευσης."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον κωδικό επαλήθευσης"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός επικύρωσης από την εφαρμογή επικύρωσης"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "en-GB": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code from the authentication app."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "en-IE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code from the authentication app."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "en-US": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter and confirm the authentication code from the authentication app."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter authentication code"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from Authentication App"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "es-ES": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduce y confirma el código de autenticación de la aplicación de autenticación."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el código de autenticación"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación de la aplicación de autenticación"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación de la aplicación de autenticación"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicación de autenticación"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "et-EE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage ja kinnitage autentimisrakenduse autentimiskood."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage autentimiskood"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood autentimisrakendusest"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood autentimisrakendusest"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimisrakendus"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        }
      },
      "fi-FI": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anna ja vahvista tunnistussovelluksen tunnistuskoodi."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjoita tunnistekoodi"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentikointikoodi autentikointisovelluksesta"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentikointikoodi autentikointisovelluksesta"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennussovellus"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        }
      },
      "fr-BE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification de l'application d'authentification."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-CH": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez et confirmez le code d'authentification de l'application d'authentification."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-FR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez et confirmez le code d'authentification de l'application d'authentification."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-LU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez et confirmez le code d'authentification de l'application d'authentification."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le code d'authentification"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification de l'application d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "ga-IE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach agus deimhnigh an cód fíordheimhnithe ón aip fíordheimhnithe."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach cód fíordheimhnithe"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód Fíordheimhnithe ón gCleas Fíordheimhnithe"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód Fíordheimhnithe ón gCleas Fíordheimhnithe"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aip Authindála"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        }
      },
      "he-IL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן ואשר את קוד האימות מאפליקציית האימות."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן קוד אימות"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות מאפליקציית האימות"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות מאפליקציית האימות"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אפליקציית אימות"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        }
      },
      "hi-IN": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणन ऐप से प्रमाणन कोड दर्ज करें और पुष्टि करें."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड दर्ज करें"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप से प्रमाणीकरण कोड"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप से प्रमाणीकरण कोड"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि करें"])}
        }
      },
      "hr-HR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite i potvrdite autentikacijski kod iz autentikacijske aplikacije."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite autentifikacijski kod"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz autentifikacijske aplikacije"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        }
      },
      "hu-HU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg és erősítse meg az hitelesítő appból származó hitelesítő kódot."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg az hitelesítő kódot"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód a hitelesítő alkalmazásból"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód a hitelesítő alkalmazásból"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő alkalmazás"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        }
      },
      "it-CH": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire e confermare il codice di autenticazione dall'app di autenticazione."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare"])}
        }
      },
      "it-IT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire e confermare il codice di autenticazione dell'app di autenticazione."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserire il codice di autenticazione"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dall'app di autenticazione"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        }
      },
      "ja-JP": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリからの認証コードを入力して確認します。"])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力してください"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリからの認証コード"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリからの認証コード"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリ"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        }
      },
      "ko-KR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱에서 인증 코드를 입력하고 확인하십시오."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드를 입력하세요"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱에서의 인증 코드"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱에서의 인증 코드"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["확인"])}
        }
      },
      "lt-LT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite ir patvirtinkite autentifikavimo kodą iš autentifikavimo programos."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite autentifikacijos kodą"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas iš autentifikacijos programos"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas iš autentifikacijos programos"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo programa"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        }
      },
      "lv-LV": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet un apstipriniet autentifikācijas kodu no autentifikācijas lietotnes."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet autentifikācijas kodu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods no autentifikācijas lietotnes"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods no autentifikācijas lietotnes"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas lietotne"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        }
      },
      "mt-MT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol u iċċekkja l-kodiċi tal-aġentazzjoni mill-app tal-aġentazzjoni."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol il-kodiċi ta' awtentikazzjoni"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' awtentiċazzjoni mill-app ta' awtentiċazzjoni"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' awtentiċazzjoni mill-app ta' awtentiċazzjoni"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App ta' awtentikazzjoni"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        }
      },
      "nb-NO": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn og bekreft godkjenningskoden fra godkjenningsappen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn godkjenningskode"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode fra autentiseringsappen"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode fra autentiseringsappen"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekrefte"])}
        }
      },
      "nl-BE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de verificatiecode in van de verificatie-app en bevestig deze."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        }
      },
      "nl-NL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de verificatiecode in van de verificatie-app en bevestig deze."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer de authenticatiecode in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de authenticatie-app"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        }
      },
      "pl-PL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź i potwierdź kod uwierzytelniania z aplikacji uwierzytelniania."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź kod uwierzytelniania"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania z aplikacji uwierzytelniania"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania z aplikacji uwierzytelniania"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacja do uwierzytelniania"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        }
      },
      "pt-PT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduza e confirme o código de autenticação da aplicação de autenticação."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insira o código de autenticação"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação do aplicativo de autenticação"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação do aplicativo de autenticação"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicativo de autenticação"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "ro-RO": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți și confirmați codul de autentificare din aplicația de autentificare."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți codul de autentificare"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare din aplicația de autentificare"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare din aplicația de autentificare"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicație de autentificare"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        }
      },
      "ru-RU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите и подтвердите код аутентификации из приложения аутентификации."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите код аутентификации"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации из приложения аутентификации"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации из приложения аутентификации"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение для аутентификации"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        }
      },
      "sk-SK": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte a potvrďte overovací kód z overovacej aplikácie."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte overovací kód"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizačný kód z autentizačnej aplikácie"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizačný kód z autentizačnej aplikácie"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačná aplikácia"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        }
      },
      "sl-SI": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite in potrdite kodo za avtentikacijo iz aplikacije za avtentikacijo."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite kodo za preverjanje pristnosti"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avtentikacijska koda iz avtentikacijske aplikacije"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avtentikacijska koda iz avtentikacijske aplikacije"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za avtentikacijo"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        }
      },
      "sv-SE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange och bekräfta autentiseringskoden från autentiseringsappen."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange autentiseringskod"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod från autentiseringsappen"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod från autentiseringsappen"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        }
      },
      "th-TH": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนและยืนยันรหัสการตรวจสอบจากแอปการตรวจสอบ."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนรหัสยืนยัน"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการรับรองจากแอปการรับรองความถูกต้อง"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการรับรองจากแอปการรับรองความถูกต้อง"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["แอปพลิเคชันการรับรองความถูกต้อง"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ยืนยัน"])}
        }
      },
      "tr-CY": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama uygulamasından doğrulama kodunu girin ve onaylayın."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "tr-TR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama uygulamasından doğrulama kodunu girin ve onaylayın."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodunu girin"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama Uygulamasından Doğrulama Kodu"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "uk-UA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть та підтвердіть код аутентифікації з додатка аутентифікації."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть код автентифікації"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації з додатка автентифікації"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації з додатка автентифікації"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Додаток для автентифікації"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        }
      },
      "vi-VN": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập và xác nhận mã xác thực từ ứng dụng xác thực."])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập mã xác thực"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực từ ứng dụng xác thực"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực từ ứng dụng xác thực"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ứng dụng Xác thực"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Xác nhận"])}
        }
      },
      "zh-CN": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入并确认来自认证应用的认证代码。"])}
        },
        "authenticatorOTP": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入认证码"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["来自身份验证应用的身份验证代码"])}
          }
        },
        "input": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["来自身份验证应用的身份验证代码"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证应用"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        }
      }
    }
  })
}
